/**
 * In a module of its own and not in `catalog-hero.tsx`, which is a client module: the tab's
 * skeleton is rendered on the server, where an import from a client module is a reference and
 * not a value (see `account/account-grid.ts`).
 */

/**
 * The hero's height on desktop: one full viewport. The prototype subtracts a header height it
 * measures inside the catalog component, where there is no header — so what it renders, and what
 * was approved, is `100svh`. Exported so the tab's skeleton reserves the exact same space.
 *
 * A **height**, not a minimum: the prototype edits the presentation inside this box, so opening
 * the form re-centres the hero's own content and never pushes the catalog below it.
 */
export const CATALOG_HERO_MIN_HEIGHT = "100svh";

/**
 * The hero's desktop height on the guest's own page (`/lista/<slug>`), where the public header is
 * fixed above it. The prototype's guest context does render its header, and there the hero is
 * `calc(100svh - <header height>)` (`heroSectionH`, measured 825px at 1440×900): the 75px header
 * every public page holds (`site-header-frame.ts`). The panel keeps `CATALOG_HERO_MIN_HEIGHT`.
 */
export const PUBLIC_LIST_HERO_HEIGHT = "calc(100svh - 75px)";
